import { render, staticRenderFns } from "./maintenance.vue?vue&type=template&id=72affd57&scoped=true&"
var script = {}
import style0 from "./maintenance.vue?vue&type=style&index=0&id=72affd57&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72affd57",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('72affd57', component.options)
    } else {
      api.reload('72affd57', component.options)
    }
    module.hot.accept("./maintenance.vue?vue&type=template&id=72affd57&scoped=true&", function () {
      api.rerender('72affd57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main/maintenance.vue"
export default component.exports